import { render, staticRenderFns } from "./batchButton.vue?vue&type=template&id=2dd643e0"
import script from "./batchButton.vue?vue&type=script&lang=js"
export * from "./batchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports